module.exports = __webpack_public_path__ + "static/media/man_zhulili.038e3a59.png";